import React from "react";
import { roundOffCost } from "../../../Components/Functions/amt.fun";

const ProjectFinancials = ({ allQData, quotationType }) => {
  let serial = 1;

  return (
    <div>
      <h3
        style={{
          marginBottom: "-10px",
        }}
      >
        Project Financials
      </h3>
      <h3
        style={{
          color: "green",
          fontSize: "1.03rem",
        }}
      >
        Estimated based on previous operational farms.
      </h3>
      <p className="fs-3 mb-0">Specifications :</p>
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td>
              <p>Result specifications</p>

              <table style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th>Specification</th>
                    <th>Unit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{serial++}.</td>
                    <td>Project size in Sqft</td>
                    <td>{allQData?.area_in.area_in_sqft}</td>
                  </tr>
                  {/* <tr>
                    <td>{serial++}.</td>
                    <td>Possible dimensions</td>
                    {/* <%= record.calculator.possible_max_project_size_in_sqmtr.join(", ") %> }
                  </tr> */}
                  <tr>
                    <td>{serial++}</td>
                    <td>Project size in SqMtr</td>
                    <td>{allQData?.area_in.area_in_sqmeter}</td>
                  </tr>
                  {quotationType !== "nvph" &&
                    quotationType !== "nethouse" &&
                    quotationType !== "fanpad" &&
                    quotationType !== "soilbasedfanpad" &&
                    quotationType !== "soilbasednvph" &&
                    quotationType !== "soilbasednethouse" && (
                      <tr>
                        <td>{serial++}.</td>
                        <td>Maximum number of plants</td>
                        <td>
                          {allQData?.number_of_plants.maximumNumberOfPlants}
                        </td>
                      </tr>
                    )}
                  {/* {allQData?.input_info.a_FramePercent > 0 ? (
                    <tr>
                      <td>{serial++}.</td>
                      <td>Number of plants (A Frame)</td>
                      <td>
                        {allQData?.number_of_plants.numberOfPlantsInA_Frame}
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}
                  {allQData?.input_info.flatBedPercent > 0 ? (
                    <tr>
                      <td>{serial++}.</td>
                      <td>Number of plants (Flat-NFT)</td>
                      <td>
                        {allQData?.number_of_plants.numberOfPlantsInFlatBed}
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}
                  {allQData?.input_info.growBagPercent > 0 ? (
                    <tr>
                      <td>{serial++}.</td>
                      <td>Number of plants (Grow Bag)</td>
                      <td>
                        {allQData?.number_of_plants.numberOfPlantsInGrowBag}
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}
                  {allQData?.input_info.dutchBucketPercent > 0 ? (
                    <tr>
                      <td>{serial++}.</td>
                      <td>Number of plants (Dutch Bucket)</td>
                      <td>
                        {allQData?.number_of_plants.numberOfPlantsInDutchBucket}
                      </td>
                    </tr>
                  ) : (
                    ""
                  )} */}
                  {/* <tr>
                    <td>{serial++}.</td>
                    <td>Plant count breakdown</td>
                    <td>{allQData?.number_of_plants.maximumNumberOfPlants}</td>
                  </tr> */}

                  {quotationType !== "nvph" &&
                    quotationType !== "fanpad" &&
                    quotationType !== "nethouse" &&
                    quotationType !== "soilbasedfanpad" &&
                    quotationType !== "soilbasednvph" &&
                    quotationType !== "soilbasednethouse" && (
                      <tr>
                        <td>{serial++}.</td>
                        <td>Fertigation tank</td>
                        <td>
                          {allQData?.liquid_require.fertilizerTankCapacity}L
                        </td>
                      </tr>
                    )}
                  {quotationType !== "nvph" &&
                    quotationType !== "fanpad" &&
                    quotationType !== "nethouse" &&
                    quotationType !== "soilbasedfanpad" &&
                    quotationType !== "soilbasednvph" &&
                    quotationType !== "soilbasednethouse" && (
                      <tr>
                        <td>{serial++}.</td>
                        <td>Solution A+B</td>
                        <td>
                          {allQData?.liquid_require.solutionTankA_Capacity +
                            allQData?.liquid_require.solutionTankB_Capacity}
                          L
                        </td>
                      </tr>
                    )}
                  {/* <tr>
                    <td>{serial++}.</td>
                    <td>Solution tank B</td>
                    <td>L</td>
                  </tr> */}

                  {quotationType !== "nvph" &&
                    quotationType !== "soilbasednvph" && (
                      <tr>
                        <td>{serial++}.</td>
                        <td>Electricity phase</td>
                        <td>{allQData?.electricityPhase} Phase</td>
                      </tr>
                    )}
                  {allQData?.input_info?.quotationType !== "nethouse" &&
                    allQData?.input_info?.quotationType !== "fanpad" &&
                    allQData?.input_info?.quotationType !== "nvph" &&
                    allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                    allQData?.input_info?.quotationType !== "soilbasednvph" &&
                    allQData?.input_info?.quotationType !==
                      "soilbasednethouse" && (
                      <>
                        {allQData?.input_info?.a_FramePercent > 0 && (
                          <tr>
                            <td>{serial++}.</td>
                            <td>UV treatment tube</td>
                            <td>{350 * allQData?.uvTreatmentTube}LPH</td>
                          </tr>
                        )}
                        <tr>
                          <td>{serial++}.</td>
                          <td>Number of labours</td>
                          <td>{allQData?.labourCount}</td>
                        </tr>
                      </>
                    )}

                  {allQData?.blocksPerType?.totalBlocks8X4MtrNew > 0 && (
                    <tr>
                      <td>{serial++}.</td>
                      <td>Total Blocks</td>
                      <td>{allQData?.blocksPerType?.totalBlocks8X4MtrNew} </td>
                    </tr>
                  )}
                  {allQData?.blocksPerType?.aframe > 0 && (
                    <tr>
                      <td>{serial++}.</td>
                      <td>A-Frame Blocks</td>
                      <td>{allQData?.blocksPerType?.aframe}</td>
                    </tr>
                  )}
                  {allQData?.blocksPerType?.fltBlock > 0 && (
                    <tr>
                      <td>{serial++}.</td>
                      <td>Flatbed Blocks</td>
                      <td>{allQData?.blocksPerType?.fltBlock}</td>
                    </tr>
                  )}
                  {allQData?.blocksPerType?.growbagBlock > 0 && (
                    <tr>
                      <td>{serial++}.</td>
                      <td>Growbags Blocks</td>
                      <td>{allQData?.blocksPerType?.growbagBlock}</td>
                    </tr>
                  )}
                  {allQData?.blocksPerType?.dutch_bucketBlok > 0 && (
                    <tr>
                      <td>{serial++}.</td>
                      <td>Dutch Bucket Blocks</td>
                      <td>{allQData?.blocksPerType?.dutch_bucketBlok} </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </td>
            {allQData?.input_info?.quotationType !== "nethouse" &&
              allQData?.input_info?.quotationType !== "fanpad" &&
              allQData?.input_info?.quotationType !== "nvph" &&
              allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
              allQData?.input_info?.quotationType !== "soilbasednvph" &&
              allQData?.input_info?.quotationType !== "soilbasednethouse" && (
                <td>
                  <p>Opex Specifications</p>

                  <table style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th>Sr.</th>
                        <th>Specification</th>

                        <th>Monthly Exp</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>{(serial = 1)}.</td>
                        <td>Seeds</td>

                        <td>
                          {roundOffCost(allQData?.opex_cost?.opex_seeds_cost)}
                        </td>
                      </tr>
                      <tr>
                        <td>{++serial}.</td>
                        <td>Grow media</td>

                        <td>
                          {roundOffCost(
                            allQData?.opex_cost?.opex_growmedia_cost
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>{++serial}.</td>
                        <td>Electricity</td>
                        {/* <td><%= record.calculator.electricity_units_per_cycle.k_to_comma_format(0) %>units</td> */}

                        {/* <td><%= record.calculator.electricity_units_per_month_expense.k_to_inr %></td> */}
                        <td>
                          {roundOffCost(
                            allQData?.opex_cost?.opex_electricity_cost
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>{++serial}.</td>
                        <td>Solution A</td>
                        {/* <td><%= record.calculator.solution_a_per_cycle.k_to_comma_format(0) %>L</td> */}

                        <td>
                          {roundOffCost(
                            allQData?.opex_cost?.opex_solutionA_cost
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>{++serial}.</td>
                        <td>Solution B</td>
                        {/* <td><%= record.calculator.solution_b_per_cycle.k_to_comma_format(0) %>L</td> */}

                        {/* <td><%= record.calculator.solution_b_per_month_expense.k_to_inr %></td> */}
                        <td>
                          {roundOffCost(
                            allQData?.opex_cost?.opex_solutionB_cost
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>{++serial}.</td>
                        <td>Packaging</td>
                        {/* <td><%= record.calculator.packaging_material_per_cycle.k_to_comma_format(0) %>bags</td> */}

                        {/* <td><%= record.calculator.packaging_material_per_month_expense.k_to_inr %></td> */}
                        <td>
                          {roundOffCost(
                            allQData?.opex_cost?.opex_packaging_cost
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>{++serial}.</td>
                        <td>Labours</td>

                        <td>
                          {roundOffCost(allQData?.opex_cost?.opex_labour_cost)}
                        </td>
                      </tr>
                      {allQData?.blocksPerType?.totalBlocks8X4MtrNew > 0 && (
                        <tr>
                          <td>{++serial}.</td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}
                      {allQData?.blocksPerType?.fltBlock > 0 && (
                        <tr>
                          <td>{++serial}.</td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}
                      {allQData?.blocksPerType?.growbagBlock > 0 && (
                        <tr>
                          <td>{++serial}.</td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}
                      {allQData?.blocksPerType?.dutch_bucketBlok > 0 && (
                        <tr>
                          <td>{++serial}.</td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}

                      <tr>
                        <td></td>
                        <td>Total opex/month (tentative)</td>

                        <td>
                          {roundOffCost(allQData?.opex_cost?.opex_all_cost)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              )}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ProjectFinancials;
